import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import VueSweetalert2 from 'vue-sweetalert2'
import VueFilterDateFormat from 'vue-filter-date-format';
// import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import axiosHttp from './axios'
import i18n from './i18n'
import router from './router'
import store from './store'
import './registerServiceWorker'

import vSelect from 'vue-select';
// import draggable from 'vuedraggable';
import vue2Dropzone from 'vue2-dropzone';
import NumericInput from './views/common/NumericInput';
import ClickOutside from 'vue-click-outside';
import VTooltip from 'v-tooltip'

import CurrencyFilter from './shared/filters/currency';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/css/light-bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.min.css';
// import '@/assets/css/nucleo-icons.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import '@/assets/css/app.css';
import '@/assets/css/table.css';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
import Notifications from 'vue-notification'

import VueMeta from 'vue-meta';
import VueCarousel from 'vue-carousel';
import {ReportSwal} from "@/shared/report-swal";

Vue.use(VueMeta);
// Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueTheMask);
Vue.use(VueSweetalert2);
Vue.use(VueFilterDateFormat);
Vue.use(VTooltip);
Vue.use(Notifications);
Vue.use(VueCarousel);
Vue.use(require('vue-cookies'))
Vue.use(ReportSwal)

Vue.component('v-select', vSelect);
Vue.component('vue-dropzone', vue2Dropzone);
Vue.component('numeric-input', NumericInput);

Vue.directive('click-outside', ClickOutside);

Vue.filter('currency', CurrencyFilter);

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$http = axiosHttp;

// Vue.prototype.goToLogin = function () {
//   window.location = process.env.VUE_APP_LOGIN_URL;
// };
Vue.prototype.hasPermission = function (permission) {
  const profile = VueApp.$store.state.profile;
  return !!(profile && profile.permissions && profile.permissions.indexOf(permission) >= 0);
};
Vue.config.productionTip = false;

Vue.prototype.hasAnyAdminRoles = function () {
    const authorities = VueApp.$store.state.profile.authorities;
    if (authorities == null) {
        return false;
    }
    for (const role of authorities) {
        if (role == "ROLE_ADMIN" || role == "ROLE_GENERAL_DIRECTOR" || role == "ROLE_DIRECTOR" || role === "ROLE_REGIONAL_LEADER") {
            return true;
        }
    }
    return false;
};

Vue.prototype.isEmptyObject = function (obj) {
    for (const prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return true;
}

export const VueApp = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
});

let instancePath = '';
if (process.env.VUE_APP_PUBLIC_PATH) {
    console.log("VUE_APP_PUBLIC_PATH = true")
    instancePath = `${process.env.VUE_APP_PUBLIC_PATH}config.json`
} else {
    console.log("VUE_APP_PUBLIC_PATH = false")
    instancePath = `/config.json`
}
fetch(instancePath)
    .then(res => res.json())
    .then(config => {
        window.runtimeConfig = config;
        VueApp.$mount('#app');
    });
